module.exports = __webpack_public_path__ + "img/mix-2.78096c58.jpg";